import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { ISnippetsService } from 'vscode/vscode/vs/workbench/contrib/snippets/browser/snippets.service';
import { IQuickInputService } from 'vscode/vscode/vs/platform/quickinput/common/quickInput.service';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { ThemeIcon } from 'vscode/vscode/vs/base/common/themables';
import { Event } from 'vscode/vscode/vs/base/common/event';

const _moduleId = "vs/workbench/contrib/snippets/browser/snippetPicker";
async function pickSnippet(accessor, languageIdOrSnippets) {
    const snippetService = accessor.get(ISnippetsService);
    const quickInputService = accessor.get(IQuickInputService);
    let snippets;
    if (Array.isArray(languageIdOrSnippets)) {
        snippets = languageIdOrSnippets;
    }
    else {
        snippets = (await snippetService.getSnippets(languageIdOrSnippets, { includeDisabledSnippets: true, includeNoPrefixSnippets: true }));
    }
    snippets.sort((a, b) => a.snippetSource - b.snippetSource);
    const makeSnippetPicks = () => {
        const result = [];
        let prevSnippet;
        for (const snippet of snippets) {
            const pick = {
                label: snippet.prefix || snippet.name,
                detail: snippet.description || snippet.body,
                snippet
            };
            if (!prevSnippet || prevSnippet.snippetSource !== snippet.snippetSource || prevSnippet.source !== snippet.source) {
                let label = '';
                switch (snippet.snippetSource) {
                    case 1 :
                        label = ( localizeWithPath(_moduleId, 0, "User Snippets"));
                        break;
                    case 3 :
                        label = snippet.source;
                        break;
                    case 2 :
                        label = ( localizeWithPath(_moduleId, 1, "Workspace Snippets"));
                        break;
                }
                result.push({ type: 'separator', label });
            }
            if (snippet.snippetSource === 3 ) {
                const isEnabled = snippetService.isEnabled(snippet);
                if (isEnabled) {
                    pick.buttons = [{
                            iconClass: ThemeIcon.asClassName(Codicon.eyeClosed),
                            tooltip: ( localizeWithPath(_moduleId, 2, 'Hide from IntelliSense'))
                        }];
                }
                else {
                    pick.description = ( localizeWithPath(_moduleId, 3, "(hidden from IntelliSense)"));
                    pick.buttons = [{
                            iconClass: ThemeIcon.asClassName(Codicon.eye),
                            tooltip: ( localizeWithPath(_moduleId, 4, 'Show in IntelliSense'))
                        }];
                }
            }
            result.push(pick);
            prevSnippet = snippet;
        }
        return result;
    };
    const picker = quickInputService.createQuickPick();
    picker.placeholder = ( localizeWithPath(_moduleId, 5, "Select a snippet"));
    picker.matchOnDetail = true;
    picker.ignoreFocusOut = false;
    picker.keepScrollPosition = true;
    picker.onDidTriggerItemButton(ctx => {
        const isEnabled = snippetService.isEnabled(ctx.item.snippet);
        snippetService.updateEnablement(ctx.item.snippet, !isEnabled);
        picker.items = makeSnippetPicks();
    });
    picker.items = makeSnippetPicks();
    if (!picker.items.length) {
        picker.validationMessage = ( localizeWithPath(_moduleId, 6, "No snippet available"));
    }
    picker.show();
    await Promise.race([Event.toPromise(picker.onDidAccept), Event.toPromise(picker.onDidHide)]);
    const result = picker.selectedItems[0]?.snippet;
    picker.dispose();
    return result;
}

export { pickSnippet };
